import { GET_INTEGRATION } from "../constants/constant";

export function getIntegration(data) {

    return {
        type: GET_INTEGRATION,
        payload: data
    }
}